import gql from "graphql-tag";

/**
 * @param {string} id
 */
export const SUBSCRIBE_SERVICE_REQUEST_BY_PK = gql`
  subscription fetchServiceRequestByPk($id: uuid!) {
    serviceRequest_by_pk(id: $id) {
      id
      priority
      created_at
      status
      updated_at
      workRequired
      serviceRequest_assigneeUser {
        email
        id
        name
      }
      serviceRequest_creatorUser {
        email
        id
        name
      }
      serviceRequest_ventilator {
        id
        condition
        manufacturer
        model
        serialNumber
        status
        type
        ventilator_location {
          id
          title
        }
        ventilator_user {
          id
          email
          name
        }
      }
    }
  }
`;
